/**
 * Renders a text blob preserving paragraph and line breaks.
 *
 * - `\\n` escape sequences are normalised to actual newlines.
 * - Two-or-more consecutive newlines split paragraphs (`<p>` per chunk).
 * - Single newlines inside a paragraph become `<br />`.
 *
 * @module busniessOffice/components/singleComment/utils/renderTextWithProperIndentation
 */

import React from "react";

/**
 * @param text - Raw comment text; falsy values fall back to "N/A".
 * @returns A React fragment with paragraph/line breaks honoured.
 */
export const renderTextWithProperIndentation = (text: string) => {
  const formattedText = (text ?? "N/A").replace(/\\n/g, "\n");
  return (
    <>
      {formattedText.split(/\n{2,}/).map((paragraph, index) => (
        <p key={index} className="mb-4">
          {paragraph.split("\n").map((line, i, arr) => (
            <React.Fragment key={i}>
              {line}
              {i < arr.length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      ))}
    </>
  );
};
